import { useCallback, useEffect } from "react";

/**
 * Hook that alerts clicks outside of the passed ref
 */
export function useOutsideAlerter(ref: any, cb: (e: Event) => void) {
  /**
   * Alert if clicked on outside of element
   */
  const handleOutside = useCallback((event: Event) => {
    const target = event.target as Node;

    if (ref.current && target && !ref.current.contains(target)) {
      cb(event);
    }
  },
    [cb, ref]
  );

  useEffect(() => {
    // Bind the event listener
    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("focusin", handleOutside);
    return () => {
      // Unbind the event listener on clean up
      try {
        document.removeEventListener("mousedown", handleOutside);
        document.removeEventListener("focusin", handleOutside);
      }
      finally { }
    };
  }, [handleOutside]);
}
